import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var VenderListRes;
export const VenderListTodo = createAsyncThunk('VenderList', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Get",
            url: process.env.REACT_APP_API_URL + 'vendor_details',
            params: {
                "vender_status": "",
                "search": data ? data : ''
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return VenderListRes = res.data

    } catch (error) {
        return VenderListRes = error.response.data
    }
})

const VenderListSlice = createSlice({
    name: 'VenderList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(VenderListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(VenderListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default VenderListSlice.reducer; 